import { DashMediaTracksMixin } from "./media-tracks.js";
import { HTMLVideoAdapter } from "@videojs/media/dom";
import { MediaTracksMixin } from "@videojs/media/media-tracks";
import { deepEqual } from "@videojs/utils/object";
import * as dashjs from "dashjs";
//#region src/adapter.ts
var DashAdapterCore = class DashAdapterCore extends MediaTracksMixin(HTMLVideoAdapter) {
	static {
		this.defaultProps = {
			src: "",
			source: null
		};
	}
	#engine;
	#src = DashAdapterCore.defaultProps.src;
	#source = DashAdapterCore.defaultProps.source;
	constructor() {
		super();
		this.#engine = dashjs.MediaPlayer().create();
		this.#engine.initialize(void 0, void 0, false);
	}
	attach(target) {
		super.attach(target);
		this.#engine.attachView(target);
	}
	detach() {
		super.detach();
		this.#engine.attachView(null);
	}
	destroy() {
		this.detach();
		this.#engine.destroy();
		super.destroy();
	}
	/**
	* Underlying playback engine — the dash.js `MediaPlayerClass` instance. An advanced escape hatch for direct engine
	* access; normal playback is driven through this element's own properties and methods.
	*/
	get engine() {
		return this.#engine;
	}
	get src() {
		return this.#src;
	}
	/** MPD URL. Setting it re-derives `source`, carrying its settings over. */
	set src(value) {
		const { engine } = this.#source ?? {};
		const next = {
			...engine && { engine },
			...value && { src: value }
		};
		this.source = Object.keys(next).length > 0 ? next : null;
	}
	/**
	* Structured source: the MPD URL in `src`, plus dash.js settings in `engine.dashJs`. Replacing it re-derives `src`.
	*
	* Dash.js takes settings on a live player, so changing `engine.dashJs` re-applies them in place instead of recreating
	* the engine.
	*/
	get source() {
		return this.#source;
	}
	set source(value) {
		const source = value ?? null;
		if (source === this.#source) return;
		const src = source?.src ?? "";
		const configChanged = !deepEqual(this.#source?.engine?.dashJs ?? null, source?.engine?.dashJs ?? null);
		const srcChanged = this.#src !== src;
		this.#source = source;
		this.#src = src;
		if (configChanged) this.#applyEngineConfig(source?.engine?.dashJs);
		if (srcChanged) this.#engine.attachSource(src);
		this.dispatchEvent(new Event("sourcechange"));
	}
	#applyEngineConfig(settings) {
		this.#engine.resetSettings();
		if (settings) this.#engine.updateSettings(settings);
	}
};
/**
* @fires sourcechange - Fired when `source` changes, either directly or by resolving a new `src`. Read `source` for the
*   new value.
* @experimental
*/
var DashAdapter = class extends DashMediaTracksMixin(DashAdapterCore) {};
//#endregion
export { DashAdapter };

//# sourceMappingURL=adapter.js.map